export const NOTIFICATION = 'NOTIFICATION';
export const NOTIFICATION_ITEM = 'NOTIFICATION_ITEM'
export const SNACKBAR = 'SNACKBAR';
export const TIME = 'TIME';
export const PRIORITIES = 'PRIORITIES';
export const DLR_INFOS = 'DLR_INFOS'